<template>
    <div>
<!--    <div style="height: 110px;border-bottom: 1px solid #f2f2f2">-->
<!--        <div class="logo-con">-->
<!--            <img src="@/assets/title.png" alt="" style="height: 40px;padding: 30px 60px;">-->
<!--            <div class="logo-title">{{$t('getpassword_title')}}</div>-->
<!--        </div>-->
<!--    </div>-->
        <div class="formmain">
            <!--手机号-->
            <el-form ref="form" :model="form" label-width="0" v-if="timeYZM">
                <el-form-item>
                    <el-input v-model="form.mobile" :placeholder="$t('getpassword_enter_number')"></el-input>
                </el-form-item>
                <el-form-item>
                 <div  @click="slide()" class="btn-check-defaut" v-if="isslide">{{$t('getpassword_verify')}}
                    </div>
                    <!-- 拼图 -->
                    <div v-if="flag" class="testCode">
                        <p class="closeBtn" style="align-items: center;">
                            <span class="closetip">{{$t('getpassword_complete_puzzle_verification')}}</span>
                            <i class="el-icon-close" @click="flag = !flag" style="padding-right: 10px"></i>
                        </p>
                        <slide-verify :l="42" :r="20" :w="320" :h="140"
                                :slider-text="$t('getpassword_drag_the_slider_to_the_right_to_fill_the_puzzle')"
                                @success="onSuccess" @fail="onFail"  @refresh="onRefresh"
                                class="slide-box" ref="slideBlock"
                        ></slide-verify>
                    </div>

                    <div  class="btn-check-succ" v-if="sucessshow">{{$t('getpassword_verification_successful')}}
                    </div>
                </el-form-item>
                <el-form-item class="flex">
                    <el-button type="primary" @click="commmitdown()" :class="[baseerp+'login','loginbtn']" :disabled="!isdown">{{$t('getpassword_next_step')}}
                    </el-button>
                    <el-button  @click="close()" class="w100" >{{$t('button_cancel')}}
                    </el-button>
                </el-form-item>
            </el-form>
<!--新密码-->
            <el-form ref="formpwd" :model="formpwd"  label-width="0" v-if="pwdshow" class="getpwd">

                <el-form-item prop="password">
                    <el-input v-model="formpwd.password" :placeholder="$t('getpassword_set_a_new_password')" type="password" prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item prop="verifypwd">
                    <el-input v-model="formpwd.verifypwd" :placeholder="$t('getpassword_confirm_new_password')" type="password" prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getvalidate('formpwd')" :class="[baseerp+'login','loginbtn']">{{$t('button_sure')}}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-dialog title="$t('getpassword_security_verification')" :close-on-click-modal="false" :visible.sync="dialogFormVisible" style="width: 750px;margin: 0 auto;overflow: hidden;border-radius: 8px" >
            <div style="padding-bottom: 10px">{{$t('getpassword_authentication')}}</div>
            <el-form ref="formphone" :model="formphone"  style="">
            <el-form-item prop="vc_mobile">
                <el-input v-model="formphone.vc_mobile" :placeholder="$t('getpassword_cell_phone_number')" disabled></el-input>
            </el-form-item>

            <el-form-item class="code" prop="vc_code">
                <el-input v-model="formphone.vc_code" :placeholder="$t('login_yzm')" style="width: 48%"></el-input>
                <el-button type="button" @click="sendvalidatecode" style="margin: 0 0 0 10px;width: 48%" v-if="show"
                           >
                     {{$t('login_sendYzm')}}
                </el-button>
                <el-button type="button" @click="sendvalidatecode" style="margin: 0 0 0 10px;width: 48%" :disabled="true" v-else
                           class="disabledbtn">
                   {{$t('login_tips_try_again',{time:YZMtime})}}
                </el-button>
            </el-form-item>
                <el-form-item  class="flex">
                    <el-button type="primary" @click="submitvalidate()" :class="[baseerp+'login','loginbtn']">{{$t('button_sure')}}
                    </el-button>

                    <el-button  @click="close()" class="w100" >{{$t('button_cancel')}}
                    </el-button>
                </el-form-item>
                </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api";
    import md5 from 'js-md5';
    import {baseerp} from "@/utils/baseUrl";

    export default {
    data() {
        return {
            baseerp:'',//公共样式

            issendYZM:false,
            flag: false,
            isSuccess: "false",
            dialogFormVisible:false,
            show: true,
            YZMbtntitle: "login_sendYzm",
            YZMtimer: null,
            YZMtime: null,
            timeYZM:true,
            pwdshow:false,
            sucessshow:false,
            isslide:true,
            isdown:false,
            getusername:'',
            form: {
                mobile: '',
            },
            formphone:{
                vc_mobile:'',
                vc_code:''
            },
            formpwd:{
                password:'',
                verifypwd:'',
                vc_login:'',
            },
        }
    },
        watch:{

        },
        mounted(){
            this.baseerp=baseerp
        },
    methods: {
        touchStartEvent(e){

        },
        slide(){
            var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
            if(this.form.mobile=="") {
                this.$message.error( this.$t('login_tips_number_empty'));
            }else  if( !reg.test(this.form.mobile)){
                this.$message.error(this.$t('login_tips_incorrect_number'));
                this.form.mobile=""
                return false;
            }else {
                this.flag=true;
            }
        },

        // 拼图成功
        onSuccess() {
            this.isSuccess = true;
            this.flag=false;
            this.isslide=false
            this.sucessshow=true
            this.isdown=true


        },
        // 拼图失败
        onFail() {
            this.isSuccess = false;
        },
        // 拼图刷新
        onRefresh() {
        },
        close(){this.$emit('close')},
        //下一步
        async commmitdown() {
                sessionStorage.setItem("phone",this.form.mobile);
                this.formphone.vc_mobile=sessionStorage.getItem('phone');
            let param = {
                vc_mobile: this.form.mobile,
            };
            let res = await API.getUserLogin(param);
            if (res.code == 1) {
                this.dialogFormVisible=true;
                this.getusername=res.vc_login;
            }
        },
        //获取验证码
        async sendvalidatecode() {
            let param = {
                vc_login: this.formphone.vc_mobile,
                type:2,
            };
            let res = await API.getVerficationCode(param);
            if (res.code == 1) {
                this.$message.success(res.message);
                this.show = false;
            } else if(res.code==-2){
                this.$router.push('/login')
                this.$message.error(res.message);
            }else {
                this.$message.error(res.message);
            }
            this.YZMtime = 60;
            let YZMtimer = setInterval(() => {
                if (this.YZMtime == 0) {
                    clearInterval(YZMtimer);
                    this.YZMbtntitle =this.$t('login_sendYzm') ;
                    this.show = true;
                    this.issendYZM=false
                } else {
                    this.issendYZM=true
                    this.YZMbtntitle = this.YZMtime + this.$t('login_tips_try_again');
                    this.YZMtime--;
                    this.show = false;
                }
            }, 1000)
        },
        async submitvalidate(){
            let param = {
                vc_login: this.formphone.vc_mobile,
                vc_code:this.formphone.vc_code,
                type:2,
            };
            let res = await API.getvalidatecode(param);
            if (res.code == 1) {
                this.$message.success(res.message);
                this.dialogFormVisible=false;
                this.timeYZM=false;
                this.pwdshow=true;

            } else if(res.code==-2){
                this.$router.push('/login')
                this.$message.error(res.message);
            }else {
                this.$message.error(res.message);
                this.formphone.vc_code=""

            }

        },
        //设置新密码
     async  getvalidate(formpwd){
         var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
                if(this.formpwd.password==""){
                    this.$message.error(this.$t('login_password_cannot_be_empty'));
                }else if (!regex.test(this.formpwd.password)) {
                    this.$message.error(this.$t('login_the_password_must_be_greater_than_6_characters_and_contain_numbers_and_letters'));
                    this.formpwd.password="";
                    this.formpwd.verifypwd="";
                }else if(this.formpwd.verifypwd==""){
                    this.$message.error(this.$t('login_confirm_password_cannot_be_empty'));
                }else if(this.formpwd.password!==this.formpwd.verifypwd){
                    this.$message.error(this.$t('login_two_passwords_are_inconsistent'));
                    this.$t('')
                    this.formpwd.password="";
                    this.formpwd.verifypwd="";
                }else{
                    var mdpwd=md5(this.formpwd.password)
                    let param = {
                        vc_mobile: this.formphone.vc_mobile,
                        vc_pwd:mdpwd.toUpperCase(),
                    };
                    let res = await API.getupdatePwd(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        // this.$router.push("/login");
                            this.$emit('close')
                    } else if(res.code==-2){
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    }else {
                        this.$message.error(res.message);
                        this.formphone.vc_code=""

                    }
                }

        },

    }
    }

</script>
<style scoped>

    .logo-con {
        width: 80%;
        margin: 0 auto;
        height: 120px;
        display: flex;
        align-items: center;
    }
    .el-form-item {
        margin-bottom: 30px;
    }
    .disabledbtn{
        background: #f6f6f6!important;
        color: #666!important;
    }
    .formmain {
        width: 320px;
        margin: 0 auto;
        margin-top: 20px;
    }
    .logo-title {
        float: left;
        height: 34px;
        line-height: 34px;
        font-size: 24px;
        color: #333;
    }

    .form-wrap {
        width: 402px;
        margin: 0 auto;
        margin-top: 65px;
    }
    .w100{
        width: 100%;

    }
    .loginbtn{
        width: 100%;
        color: #fff;
        /*background: #E89112;*/
        /*border-color: #E89112;*/
    }
    .el-dialog__header{
        border-bottom: 1px solid #f2f2f2;
    }
   /deep/.flex .el-form-item__content{
       display: flex;
       width: 100%;
    }
    .testCode{
        /*position: absolute;*/
        top: -308px;
    }
    .slide-verify-slider{
        width: 320px!important;
    }
    .btn-check-defaut {
        width: 100%;
        background: #f3f3f3;
        border: 1px solid #ccc;
        font-size: 14px;
        color: #999;
        letter-spacing: -.25px;
        text-align: center;
        border-radius: 8px;
    }
    .closeBtn{
        display: flex;
        justify-content: space-between;
    }
    .closetip{
        font-size: 14px;
        color: #666;
        padding: 0 10px;
    }
    .btn-check-succ{
        background: #fff;
        border: 1px solid #ccc;
        font-size: 14px;
        color: #0c8;
        text-align: center;
        border-radius: 8px;

    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #FFF;
        /*background-color: #E89112;*/
        /*border-color: #E89112;*/
        opacity: 0.5;

    }
    /deep/.el-dialog{
        border-radius: 8px;
    }
</style>